/**
 * Scryze Hero Slideshow - Autoplay, dots, swipe, video reset, staged content animations
 * Binds only to [data-scryze-hero] elements
 */
(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHero(container) {
    if (container.dataset.scryzeInitialized === 'true') return;
    container.dataset.scryzeInitialized = 'true';

    const track = container.querySelector('.scryze-hero__track');
    const slides = container.querySelectorAll('.scryze-hero__slide');
    const dots = container.querySelectorAll('.scryze-hero__dot');
    const slideCount = slides.length;

    if (slideCount <= 0 || !track) return;

    let currentIndex = 0;
    const autoplay = container.dataset.autoplay === 'true';
    const intervalSec = parseInt(container.dataset.interval || '5', 10) * 1000;
    let autoplayTimer = null;
    let enterTimeouts = [];
    let scheduleTimeoutId = null;
    let touchStartX = 0;
    let touchEndX = 0;

    function clearEnterTimeouts() {
      if (scheduleTimeoutId) {
        clearTimeout(scheduleTimeoutId);
        scheduleTimeoutId = null;
      }
      enterTimeouts.forEach((id) => clearTimeout(id));
      enterTimeouts = [];
    }

    function resetAllContentToHidden() {
      container.classList.add('is-resetting');
      slides.forEach((slide) => {
        slide.querySelectorAll('[data-scryze-hero-heading], [data-scryze-hero-subtext], [data-scryze-hero-buttons]').forEach((el) => {
          el.classList.remove('is-entered');
        });
      });
      void container.offsetHeight;
      container.classList.remove('is-resetting');
    }

    function triggerStagedEnter(activeSlide) {
      if (!activeSlide) return;
      const targetIndex = Array.from(slides).indexOf(activeSlide);

      const heading = activeSlide.querySelector('[data-scryze-hero-heading]');
      const subtext = activeSlide.querySelector('[data-scryze-hero-subtext]');
      const buttons = activeSlide.querySelector('[data-scryze-hero-buttons]');

      enterTimeouts.push(setTimeout(() => {
        if (Array.from(slides).indexOf(container.querySelector('.scryze-hero__slide.is-active')) !== targetIndex) return;
        if (subtext) subtext.classList.add('is-entered');
      }, 120));

      enterTimeouts.push(setTimeout(() => {
        if (Array.from(slides).indexOf(container.querySelector('.scryze-hero__slide.is-active')) !== targetIndex) return;
        if (heading) heading.classList.add('is-entered');
      }, 220));

      enterTimeouts.push(setTimeout(() => {
        if (Array.from(slides).indexOf(container.querySelector('.scryze-hero__slide.is-active')) !== targetIndex) return;
        if (buttons) buttons.classList.add('is-entered');
      }, 360));
    }

    function preloadNextMedia(nextIdx) {
      if (nextIdx < 0 || nextIdx >= slideCount) return;
      const slide = slides[nextIdx];
      const mediaType = slide.dataset.mediaType || '';

      if (mediaType === 'youtube') {
        const iframe = slide.querySelector('.scryze-hero__youtube-iframe');
        if (iframe && iframe.dataset.src && !iframe.src) {
          iframe.src = iframe.dataset.src;
        }
      } else if (mediaType === 'image') {
        const url = slide.dataset.imageSrc;
        if (url) {
          const img = new Image();
          img.src = url;
        }
      } else if (mediaType === 'shopify_video') {
        const video = slide.querySelector('video');
        if (video) {
          video.load();
        }
      }
    }

    function scheduleMediaReady(activeSlide) {
      if (!activeSlide) return;
      const mediaType = activeSlide.dataset.mediaType || '';

      if (mediaType === 'image') {
        const img = activeSlide.querySelector('.scryze-hero__media-wrap img:not(.scryze-hero__poster)');
        if (img) {
          if (img.complete) {
            activeSlide.classList.add('is-media-ready');
          } else {
            img.addEventListener('load', () => activeSlide.classList.add('is-media-ready'), { once: true });
            setTimeout(() => activeSlide.classList.add('is-media-ready'), 500);
          }
        } else {
          activeSlide.classList.add('is-media-ready');
        }
      } else if (mediaType === 'shopify_video') {
        const video = activeSlide.querySelector('video');
        if (video) {
          const onReady = () => {
            if (!activeSlide.classList.contains('is-media-ready')) {
              activeSlide.classList.add('is-media-ready');
            }
          };
          video.addEventListener('canplay', onReady, { once: true });
          video.addEventListener('canplaythrough', onReady, { once: true });
          setTimeout(onReady, 400);
        } else {
          activeSlide.classList.add('is-media-ready');
        }
      } else if (mediaType === 'youtube') {
        setTimeout(() => {
          if (Array.from(slides).indexOf(container.querySelector('.scryze-hero__slide.is-active')) === Array.from(slides).indexOf(activeSlide)) {
            activeSlide.classList.add('is-media-ready');
          }
        }, 700);
      } else {
        activeSlide.classList.add('is-media-ready');
      }
    }

    function goToSlide(index) {
      if (index < 0) index = slideCount - 1;
      if (index >= slideCount) index = 0;

      preloadNextMedia(index);

      const prevIndex = currentIndex;
      currentIndex = index;

      clearEnterTimeouts();
      resetAllContentToHidden();

      slides.forEach((slide, i) => {
        slide.classList.remove('is-media-ready');
        slide.classList.remove('is-active');
        slide.classList.remove('is-prev');
      });

      if (prevIndex !== currentIndex) {
        const prevSlide = slides[prevIndex];
        if (prevSlide) prevSlide.classList.add('is-prev');
      }

      const activeSlideEl = slides[currentIndex];
      activeSlideEl.classList.add('is-active');

      slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        const iframe = slide.querySelector('.scryze-hero__youtube-iframe');
        if (i === currentIndex) {
          if (video) {
            video.currentTime = 0;
            video.play().catch(() => {});
          }
          if (iframe && iframe.dataset.src) {
            iframe.src = iframe.dataset.src;
          }
          scheduleMediaReady(slide);
        } else {
          if (video) {
            video.pause();
          }
          setTimeout(() => {
            if (slide.classList.contains('is-active')) return;
            if (iframe) iframe.src = '';
          }, 650);
        }
      });

      if (prevIndex !== currentIndex && prevIndex >= 0 && prevIndex < slideCount) {
        setTimeout(() => {
          slides[prevIndex].classList.remove('is-prev');
        }, 750);
      }

      dots.forEach((dot, i) => {
        dot.classList.toggle('scryze-hero__dot--active', i === currentIndex);
        dot.setAttribute('aria-selected', i === currentIndex);
      });

      const targetIdx = currentIndex;
      scheduleTimeoutId = setTimeout(() => {
        scheduleTimeoutId = null;
        if (Array.from(slides).indexOf(container.querySelector('.scryze-hero__slide.is-active')) !== targetIdx) return;
        triggerStagedEnter(activeSlideEl);
      }, 0);

      if (autoplay) resetAutoplay();

      if (slideCount > 1) {
        const nextIdx = (currentIndex + 1) % slideCount;
        preloadNextMedia(nextIdx);
      }
    }

    function next() {
      goToSlide(currentIndex + 1);
    }

    function prev() {
      goToSlide(currentIndex - 1);
    }

    function resetAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
      if (!autoplay || reduceMotion) return;
      autoplayTimer = setInterval(next, intervalSec);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goToSlide(i));
    });

    const scrollIndicator = container.querySelector('.scryze-hero__scroll-indicator');
    if (scrollIndicator) {
      scrollIndicator.addEventListener('click', () => {
        const heroSection = container.closest('section.shopify-section') || container.closest('[data-section-id]');
        if (!heroSection) return;
        let next = heroSection.nextElementSibling;
        while (next) {
          if (next.matches && (next.matches('section.shopify-section') || next.hasAttribute('data-section-id'))) {
            const header = document.querySelector('.section-header, #shopify-section-header, header.header');
            const offset = header ? header.offsetHeight : 0;
            const rect = next.getBoundingClientRect();
            const y = rect.top + window.pageYOffset - offset;
            if (reduceMotion) {
              window.scrollTo({ top: y });
            } else {
              window.scrollTo({ top: y, behavior: 'smooth' });
            }
            return;
          }
          next = next.nextElementSibling;
        }
      });
    }

    container.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches ? e.changedTouches[0].screenX : e.touches[0].screenX;
    }, { passive: true });

    container.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next();
        else prev();
      }
    }, { passive: true });

    goToSlide(0);
    if (autoplay) resetAutoplay();

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else if (autoplay) resetAutoplay();
    });
  }

  function init() {
    document.querySelectorAll('[data-scryze-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target.querySelector('[data-scryze-hero]');
    if (el) initHero(el);
  });
})();
